import { cancelSourcingMaterial } from "@/apis/requirementManagement.api";
import CommonModal from "@/components/ui/CommonModal";
import { useModal } from "@/hooks/modals/useModal";
import { cancelSourcingApplicationSchema } from "@/types/apis";
import { notifySuccess } from "@/utils/notification";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Form, Input } from "antd";

type Props = {
  sourcingMaterialId: number | null;
  open: boolean;
  onClose: () => void;
  onOk: () => void;
};

type FormFields = {
  cancelReason: string;
};

export const CancelReasonModal: React.FC<Props> = ({
  open,
  onClose,
  onOk,
  sourcingMaterialId,
}) => {
  const [form] = Form.useForm<FormFields>();
  const { props } = useModal("SOURCING_APPLICATION_20251202");

  const queryClient = useQueryClient();

  const cancelMutation = useMutation({
    mutationFn: (data: cancelSourcingApplicationSchema) =>
      cancelSourcingMaterial(data),
    onSuccess() {
      notifySuccess("取消成功");
      form.resetFields();
      queryClient.invalidateQueries({
        queryKey: ["querySourcingRequirementDetail", props.recordId],
      });
      onOk();
    },
  });

  const handleOnOk = async () => {
    if (!sourcingMaterialId) return;
    const values = await form.validateFields();
    cancelMutation.mutate({
      sourcingMaterialId: sourcingMaterialId,
      cancelReason: values.cancelReason,
    });
  };

  return (
    <CommonModal
      title="取消寻源原因"
      open={open}
      onOk={handleOnOk}
      onCancel={onClose}
      okButtonProps={{
        loading: cancelMutation.isPending,
      }}
      width={500}
    >
      <Form form={form} disabled={false} initialValues={{ cancelReason: "" }}>
        <Form.Item<FormFields> name="cancelReason">
          <Input.TextArea rows={4} placeholder="请输入取消寻源的原因" />
        </Form.Item>
      </Form>
    </CommonModal>
  );
};
